import type { TenantPluginRegister } from './types'

/** Drop in-tree domain bundles the tenant pack says it provides (`export const providesDomains`). */
export function activeDomainBundles(
  bundles: ReadonlyArray<readonly [string, TenantPluginRegister]>,
  providesDomains: unknown,
): Array<readonly [string, TenantPluginRegister]> {
  const provided = new Set(
    Array.isArray(providesDomains) ? providesDomains.filter((d) => typeof d === 'string') : [],
  )
  return bundles.filter(([name]) => !provided.has(name))
}
